export const metricConversionRates = Object.freeze({
  mileToMeter: 1609.34,
  mileToKilometer: 1.60934,
  kilometerToFoot: 3280.84,
  meterToFoot: 3.28084,
  imperialTonToMetricTon: 1.01605,
  cubicMeterToCubicYard: 1.30795,
  generalCubicYardToImperialTon: 1.4
});
